import { Grid, Box, Chip } from '@mui/material'
import {
    GridColumnHeaderParams,
    type GridColDef,
    type GridRenderCellParams,
} from '@mui/x-data-grid'
import React from 'react'
import LocatedDataGrid from './ImportsDataGrid'
import ChartBlock from '../../../../components/features/ChartBlock'
import { HistoricList } from '../../../../redux/imports/importsTypes'
import { BLACK, WHITE } from '../../../../components/ui/Colors'
import { PrimaryText, SecondaryText } from '../../../../components/ui/Text'
import { periodsList } from '../../../../components/features/export/FsExportRawSelectStep'
import { chipConfig, ImportSatus } from './Import'

interface OwnProps {
    list: HistoricList[]
}

const CustomizedChip = ({ status }: { status: string }) => {
    return (
        <Chip
            label={chipConfig[status].title}
            sx={{
                color: status === ImportSatus.IN_PROGRESS ? WHITE : BLACK,
                background: chipConfig[status].color,
                '& span': {
                    paddingLeft: '0.5vw',
                    paddingRight: '0.5vw',
                },
            }}
        />)
}

const columns: GridColDef[] = [
    {
        field: 'filename',
        headerName: 'Nom du fichier',
        flex: 1,
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <PrimaryText color={BLACK}>
                    {params.colDef.headerName}
                </PrimaryText>
            )
        },
        renderCell: (params: GridRenderCellParams) => {
            return <SecondaryText color={BLACK}>{params.value}</SecondaryText>
        },
    },
    {
        field: 'distributorName',
        headerName: 'Distributeur',
        flex: 1,
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <PrimaryText color={BLACK}>
                    {params.colDef.headerName}
                </PrimaryText>
            )
        },
        renderCell: (params: GridRenderCellParams) => {
            return <SecondaryText color={BLACK}>{params.value}</SecondaryText>
        },
    },
    {
        field: 'period',
        headerName: 'Période de données',
        flex: 1,
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <PrimaryText color={BLACK}>
                    {params.colDef.headerName}
                </PrimaryText>
            )
        },
        renderCell: (params: GridRenderCellParams) => {
            if (params.value) {
                const year = params.value.slice(0, 4)
                const month = params.value.slice(5, 7)

                return (
                    <SecondaryText color={BLACK}>
                        {`${periodsList[month]} ${year}`}
                    </SecondaryText>
                )
            }
        },
        sortable: false,
    },
    {
        field: 'username',
        headerName: 'Déposé par',
        flex: 1,
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <PrimaryText color={BLACK}>
                    {params.colDef.headerName}
                </PrimaryText>
            )
        },
        renderCell: (params: GridRenderCellParams) => {
            return <SecondaryText color={BLACK}>{params.value}</SecondaryText>
        },
    },
    {
        field: 'status',
        headerName: 'Statut',
        flex: 1,
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <PrimaryText color={BLACK}>
                    {params.colDef.headerName}
                </PrimaryText>
            )
        },
        renderCell: (params: GridRenderCellParams) => {
            const { status } = params.row

            return status && <CustomizedChip status={status} />
        },
    },
    {
        field: 'message',
        headerName: 'Commentaire',
        flex: 1,
        renderHeader: (params: GridColumnHeaderParams) => {
            return (
                <PrimaryText color={BLACK}>
                    {params.colDef.headerName}
                </PrimaryText>
            )
        },
        renderCell: (params: GridRenderCellParams) => {
            return <SecondaryText color={BLACK}>{params.value}</SecondaryText>
        },
    },
]

const NoRows = () => {
    return (
        <Grid
            container
            justifyContent="center"
            alignContent="center"
            sx={{ height: '100%' }}
        >
            <PrimaryText color={BLACK} >
                Pas de résultat, importez un fichier.
            </PrimaryText>
        </Grid>
    )
}

const ImportHistoric = ({ list }: OwnProps) => {
    return (
        <ChartBlock title="Historique">
            <Box sx={{ height: '34vh' }}>
                <LocatedDataGrid
                    getRowId={(row) => row._id}
                    rows={list}
                    columns={columns}
                    components={{
                        NoRowsOverlay: () => <NoRows />,
                    }}
                />
            </Box>
        </ChartBlock>
    )
}

export default ImportHistoric
